<div class="comments-container">
    <div class="comments-header">
        <span class="title">{{ title }}</span>
        <button mat-icon-button (click)="hideChat.emit()">
            <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
        </button>
    </div>

    <div #scrollContainer class="comments-body">
        @for (comment of comments; track comment; let i = $index) {
            <chat-comment
                [comment]="comment"
                [userColor]="userColors.get(comment.userId)"
                [triggerAfterRendered]="i === comments.length - 1"
                [dataUiid]="'cerrix-chat-comment-' + comment.id"
                (afterRendered)="afterLastCommentDisplayed()"
            ></chat-comment>
        }
    </div>

    @if (canAdd) {
        <div class="comments-footer">
            <div class="add-comment-container">
                <cerrix-textarea
                    [placeholder]="placeholder"
                    [formControl]="commentTextForm"
                    [textareaAutosize]="true"
                    [autosizeMinRows]="1"
                    [autosizeMaxRows]="8"
                    [dataUiid]="'cerrix-chat-comment-textarea'"
                ></cerrix-textarea>
            </div>

            <button
                [disabled]="!commentTextForm.value || loading"
                mat-flat-button
                [attr.data-uiid]="'cerrix-chat-add-comment-button'"
                class="add-comment-button"
                (click)="onAddComment()"
            >
                <mat-icon fontSet="material-icons-outlined">send</mat-icon>
            </button>
        </div>
    }
</div>
